import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { LogIn, ShieldCheck } from "lucide-react";

export default function Login() {
  const [params] = useSearchParams();
  const denied = params.get("error") === "denied";

  const login = () => {
    const redirect = `${window.location.origin}/admin`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-5 relative overflow-hidden" data-testid="admin-login">
      <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: "radial-gradient(#fff 1px, transparent 1px)", backgroundSize: "22px 22px" }} />
      <motion.div
        initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="relative w-full max-w-md border border-white/10 bg-[#0a0a0a] p-8 md:p-10"
      >
        <div className="font-display text-4xl tracking-tight leading-none mb-2">
          <span className="text-[#E30613]">VL</span><span>MAG</span>
        </div>
        <p className="text-[10px] uppercase tracking-[0.3em] font-bold text-neutral-500 mb-8">Team Operations · Secure Access</p>

        <h1 className="font-display uppercase text-2xl md:text-3xl leading-[0.95] tracking-tight mb-3">Welcome to the collective</h1>
        <p className="text-sm text-neutral-400 leading-relaxed mb-8">
          Sign in with your VLMAG team Google account. Access is restricted to authorized team members only.
        </p>

        {denied && (
          <div data-testid="login-denied" className="border border-[#E30613] bg-[#E30613]/10 text-sm text-neutral-200 p-4 mb-6">
            That account isn't on the VLMAG team access list. Use an authorized team email, or contact an admin.
          </div>
        )}

        <button
          onClick={login}
          data-testid="google-login-button"
          className="group w-full inline-flex items-center justify-center gap-3 bg-white text-black h-14 text-sm uppercase tracking-[0.2em] font-bold hover:bg-neutral-200 transition-colors"
        >
          <LogIn size={18} /> Continue with Google
        </button>

        <p className="mt-6 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.15em] font-bold text-neutral-600">
          <ShieldCheck size={14} className="text-[#E30613]" /> 4-member team · allowlisted
        </p>
      </motion.div>
    </div>
  );
}
